export default __webpack_public_path__ + "img/bNwnzaoF.22ede4a5.svg";